<script lang="ts">
    import ProductMainImage from "./ProductMainImage.svelte"
    import ProductSelectImages from "./ProductSelectImages.svelte"
    let {
        product,
        setActiveImageCallback,
    }: {
        product: Product
        setActiveImageCallback: (fn: (idx: number) => void) => void
    } = $props()

    let setActiveImage = (idx: number) => {
        selectedImgIdx = idx
    }
    setActiveImageCallback(setActiveImage)
    let selectedImgIdx = $state(0)
</script>

<section>
    <ProductMainImage
        image={product.images?.[selectedImgIdx]}
        {product}
        shadow={selectedImgIdx === 0}
        showLasersheetActivation={product.lasersheet_configurator?.length > 0}
    />
    {#if product.images?.length > 1}
        <ul>
            {#each product.images as image, idx}
                <ProductSelectImages {image} bind:selectedImgIdx {idx} {product} shadow={idx === 0} />
            {/each}
        </ul>
    {/if}
</section>

<style lang="less">
    @import "../../../../../css/variables.less";
    section {
        ul {
            display: flex;
            overflow: auto;
            flex-wrap: nowrap;
            width: 100%;
            gap: 1rem;
            margin: 1rem 0px;
            @media @desktop {
                display: grid;
                grid-template-columns: repeat(auto-fill, minmax(170px, 1fr));
            }
        }
    }
</style>
